import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route (pathname) changes, but NOT on language switch.
 * We detect language switch by comparing the leading /ec or /en segment:
 * if only the language segment changed and the rest of the path is equal,
 * we skip the scroll.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = window.__ecu_prev_path__;
    window.__ecu_prev_path__ = pathname;

    if (prev) {
      const stripLang = (p) => p.replace(/^\/(ec|en)(?=\/|$)/, "");
      if (stripLang(prev) === stripLang(pathname)) {
        // Language-only switch. Do not scroll.
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
